import React from 'react'

type sessionType = {
    user?: sharedTypes.User,
    logout: ()=>void
}
export default React.createContext<sessionType>({
    user: {email: '', name: '', contactId: ''},
    logout: () => {console.warn('sessionContext not defined')}
});